// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorStockLocations = (client) => ({
    /**
     * `POST /vendor/stock-locations`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateStockLocation
     * @source packages/modules/b2c-core/src/api/vendor/stock-locations/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/stock-locations", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/stock-locations/:id/fulfillment-providers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateStockLocationFulfillmentProviders
     * @source packages/modules/b2c-core/src/api/vendor/stock-locations/[id]/fulfillment-providers/route.ts
     */
    createFulfillmentProvider: (id, body, query, headers) => client.fetch(buildPath("/vendor/stock-locations/:id/fulfillment-providers", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/stock-locations/:id/fulfillment-sets`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateStockLocationFulfillmentSet
     * @source packages/modules/b2c-core/src/api/vendor/stock-locations/[id]/fulfillment-sets/route.ts
     */
    createFulfillmentSet: (id, body, query, headers) => client.fetch(buildPath("/vendor/stock-locations/:id/fulfillment-sets", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/stock-locations/:id/sales-channels`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateStockLocationSalesChannels
     * @source packages/modules/b2c-core/src/api/vendor/stock-locations/[id]/sales-channels/route.ts
     */
    createSalesChannel: (id, body, query, headers) => client.fetch(buildPath("/vendor/stock-locations/:id/sales-channels", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/stock-locations/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteStockLocationById
     * @source packages/modules/b2c-core/src/api/vendor/stock-locations/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/stock-locations/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/stock-locations`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListStockLocations
     * @source packages/modules/b2c-core/src/api/vendor/stock-locations/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/stock-locations", { method: "GET", query, headers }),
    /**
     * `GET /vendor/stock-locations/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetStockLocation
     * @source packages/modules/b2c-core/src/api/vendor/stock-locations/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/stock-locations/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/stock-locations/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateStockLocation
     * @source packages/modules/b2c-core/src/api/vendor/stock-locations/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/stock-locations/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=stock-locations.js.map